<div class="field min-w-0">
  <label *ngIf="label" class="pp-label">
    {{ label }}
    <span *ngIf="required" class="red-asterisk"> *</span>
  </label>
  <ng-content></ng-content>
  <small *ngIf="error" class="acan-field__error p-error">{{ error }}</small>
</div>
